import { TranslationObject } from '../i18n/translation';

const namespace = 'agreementtable.psa';
const translations: TranslationObject = {
  ansvarligHeader: {
    id: `${namespace}.ansvarligHeader`,
    nb: 'Ansvarlig',
    en: 'Contact person',
  },
  avtalenavnHeader: {
    id: `${namespace}.avtalenavnHeader`,
    nb: 'Avtalenavn',
    en: 'Agreement name',
  },
  handlingHeader: {
    id: `${namespace}.handlingHeader`,
    nb: 'Handling',
    en: 'Action',
  },
  institusjonHeader: {
    id: `${namespace}.institusjonHeader`,
    nb: 'Institusjon',
    en: 'Institution',
  },
  sluttdatoHeader: {
    id: `${namespace}.sluttdatoHeader`,
    nb: 'Sluttdato',
    en: 'To date',
  },
  startdatoHeader: {
    id: `${namespace}.startdatoHeader`,
    nb: 'Startdato',
    en: 'From date',
  },
  statusHeader: {
    id: `${namespace}.statusHeader`,
    nb: 'Status',
    en: 'Status',
  },
  aktivStatus: {
    id: `${namespace}.aktivStatus`,
    nb: 'Signert og aktiv',
    en: 'Signed and active',
  },
  inaktivStatus: {
    id: `${namespace}.inaktivStatus`,
    nb: 'Signert og inaktiv',
    en: 'Signed and inactive',
  },
  avsluttetStatus: {
    id: `${namespace}.avsluttetStatus`,
    nb: 'Avsluttet',
    en: 'Terminated',
  },
  klarForSigneringStatus: {
    id: `${namespace}.klarForSigneringStatus`,
    nb: 'Klar for singnering',
    en: 'Ready to be signed',
  },
  ikkeKlarForSigneringStatus: {
    id: `${namespace}.ikkeKlarForSigneringStatus`,
    nb: 'Ikke klargjort for singnering',
    en: 'Not ready to be signed',
  },
  visAvtale: {
    id: `${namespace}.visAvtale`,
    nb: 'Vis avtale',
    en: 'Show agreement',
  },
  ingen: {
    id: `${namespace}.ingen`,
    nb: 'Ingen',
    en: 'None',
  },
  avtaleEmptyStateTitle: {
    id: `${namespace}.avtaleEmptyStateTitle`,
    nb: 'Det er ingen praksisavtaler å vise',
    en: 'There are no practice place agreements to show',
  },
  avtaleEmptyStateText: {
    id: `${namespace}.avtaleEmptyStateText`,
    nb: 'Det finnes ikke, eller du mangler tilgang til å se, inngåtte praksisavtaler med studiesteder. Ta kontakt med en leder innad i din organisasjon, eller kontakt en administrator ved et aktuelt studiested, for å inngå en avtale om praksis.',
    en: 'It does either not exist, or you do not have access to, practice place agreements with institutions. Contact a supervisor at your organization or an administrator at an institution to enter into an agreement of practice.',
  },
};

export default translations;
